import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { CompositePickerStore } from 'owa-calendar-composite-picker';

interface CalendarChannelPickerStore {
    viewStates: ObservableMap<string | null, CompositePickerStore>;
}

const store: CalendarChannelPickerStore = {
    viewStates: new ObservableMap<string | null, CompositePickerStore>(),
};

export const getStore = createStore<CalendarChannelPickerStore>(
    'CalendarChannelPickerStore',
    store
);
